/*
 * @Description:
 * @Version:
 * @Autor: baichenhui
 * @Date: 2021-08-25 11:36:31
 */
export default {
  drugApi: {
    getStoreBillsInfos: 'drugstore-api/webapi/store-bills-info/get-store-bills-infos', // 获取药单列表，分不同药房能配不同药物
    finishAssembly: 'drugstore-api/webapi/store-bills-info/finish-assembly', // 配药完成
    finishProvide: 'drugstore-api/webapi/store-bills-info/finish-provide', // 发药完成
    getOrinfoWithPayBillsDetails: 'drugstore-api/webapi/store-bills-info/get-orinfo-with-pay-bills-details', // 获取某个药单的处方单明细
    drugFinishPrint: 'drugstore-api/webapi/store-bills-info/finish-print', // 已经打印
    payBillsDetailsStoreReturn: 'drugstore-api/webapi/store-bills-info/make-sure-store-bill-return', // 确定退药（注意：只针对门诊，先不支持住院） POST
    getOrinfoWithPbdsBySerialNumber: 'drugstore-api/webapi/store-bills-info/get-store-bills-infos-for-return', //  根据流水号serial_number获取某个病人的药单明细，用于退药（注意：只针对门诊，先不支持住院） GET
    medicineIn: 'drugstore-api/webapi/store-medicine-inout/medicine-in', // 入库
    medicineOut: 'drugstore-api/webapi/store-medicine-inout/medicine-out', // 出库
    drugListSearch: 'drugstore-api/webapi/store-medicine-inout/list-search', // 药品出入库查询
    drugListLowQuantity: 'system-api/webapi/medicine-info/list-low-quantity', // 获取低储药品列表
    drugSearchProvide: 'drugstore-api/webapi/store-bills-info/search-provide', // 发药查询
    drugSearchReturn: 'drugstore-api/webapi/store-bills-info/search-return', // 退药查询
    storeMedicineListSearch: 'system-api/webapi/store-medicine/list-search', // 药品查询
    storeMedicineUpdate: 'system-api/webapi/store-medicine/update', // 修改
    getDstinationDepartment: 'system-api/webapi/department/get-tree',
    getMaterialDispenseList: 'drugstore-api/webapi/outpatient-material-dispense/get-list', // 门诊耗材分配列表
    getMaterialDispenseDetail: 'drugstore-api/webapi/outpatient-material-dispense/get-detail', // 门诊耗材分配明细
    postFinishProvide: 'drugstore-api/webapi/outpatient-material-dispense/finish-provide', // 门诊耗材分配
    getInpatientDispenseList: 'drugstore-api/webapi/inpatient-material-dispense/get-list', // 住院耗材分配列表
    getInpatientDispenseDetail: 'drugstore-api/webapi/inpatient-material-dispense/get-detail', // 住院耗材分配明细
    postInpatientFinishProvide: 'drugstore-api/webapi/inpatient-material-dispense/finish-provide', // 住院耗材分配
    outPatientMaterialFinishReceive: '/drugstore-api/webapi/outpatient-material-dispense/finish-receive',  // 门诊完成领用
    inPatientMaterialFinishReceive: '/drugstore-api/webapi/inpatient-material-dispense/finish-receive'// 住院完成领用
  }
}
